export interface ThresholdOverrides {
  score_floor: number;
  result_max_threshold: number;
  result_mean_threshold: number;
  page_size: number;
  similarity_threshold: number;
  vector_similarity_weight: number;
}

export const THRESHOLD_DEFAULTS: ThresholdOverrides = {
  score_floor: 0.15,
  result_max_threshold: 0.60,
  result_mean_threshold: 0.40,
  page_size: 30,
  similarity_threshold: 0.2,
  vector_similarity_weight: 0.3,
};

export const ALLOWED_THRESHOLD_KEYS: Array<keyof ThresholdOverrides> = Object.keys(THRESHOLD_DEFAULTS) as Array<keyof ThresholdOverrides>;
